<template>
    <div class="w-100 advanced-search">
        <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">Translations</h2>

        <vx-card>
            <div class="d-flex w-100 justify-center">
                <vx-input-group class="custom-input-group concepts-search w-75">
                    <div class="d-flex">
                        <div class="relative flex-grow">
                            <vs-input loading v-model="filters._search"
                                      style="width: 100%"
                                      placeholder="Type at least 3 characters."
                                      class="has-icons"
                            />
                            <div class="icons">
                                <feather-icon v-if="filters._search" icon="XIcon"
                                              svgClasses="h-6 w-6 cursor-pointer"
                                              @click="clearSearch"
                                              style="opacity: 0.7; margin-right: 5px;"/>
                                <div v-if="isLoading" class="vs-input__loading"
                                     style="margin-left: 5px;"/>
                                <feather-icon
                                    v-else
                                    style="margin-right: 5px;"
                                    icon="SearchIcon" svgClasses="h-6 w-6" :class="{'active-search-btn': isLoading}"/>
                            </div>
                        </div>
                    </div>
                </vx-input-group>
            </div>
            <div class="vx-row gutter-half mb-5 mt-3 d-flex align-center">
                <div class="vx-col w-full sm:w-full md:w-1/4">
                    <div class="d-flex align-center">
                        <span class="label">LM Format: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select LM Format"
                                  :options="lmFormats"
                                  label="name"
                                  @input="() => { getGoals() }"
                                  :reduce="item => item._id"
                                  v-model="filters.lm_format">
                            <template #list-header>
                                <li style="text-align: center" v-if="!lmFormats.length">Loading LM Formats...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !goals.length}">
                    <div class="d-flex align-center">
                        <span class="label">Goal: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Goal"
                                  :options="goals"
                                  label="name"
                                  @input="() => { getGrades(); }"
                                  :reduce="item => item.name"
                                  :disabled="!goals.length"
                                  v-model="filters.goal">
                            <template #list-header>
                                <li style="text-align: center" v-if="!goals.length">Loading Goals...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !grades.length}">
                    <div class="d-flex align-center">
                        <span class="label">Grade: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Grade"
                                  :options="grades"
                                  label="name"
                                  @input="() => { getSubjects(); }"
                                  :disabled="!grades.length"
                                  :reduce="item => item.name"
                                  v-model="filters.grade">
                            <template #list-header>
                                <li style="text-align: center" v-if="!grades.length">Loading Grades...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4" :class="{'filter-disabled': !subjects.length}">
                    <div class="d-flex align-center">
                        <span class="label">Subject: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Subject"
                                  :options="subjects"
                                  label="name"
                                  :disabled="!subjects.length"
                                  :reduce="item => item.name"
                                  @input="() => { getUnits(); }"
                                  v-model="filters.subject">
                            <template #list-header>
                                <li style="text-align: center" v-if="!subjects.length">Loading Subjects...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half mb-5 d-flex align-center">
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex align-center" :class="{'filter-disabled': !units.length}">
                        <span class="label">Unit: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Unit"
                                  :options="units"
                                  label="name"
                                  :reduce="item => item.name"
                                  :disabled="!units.length"
                                  @input="() => { getChapters(); }"
                                  v-model="filters.unit">
                            <template #list-header>
                                <li style="text-align: center" v-if="!units.length">Loading Units...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex align-center" :class="{'filter-disabled': !chapters.length}">
                        <span class="label">Chapter: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Chapter"
                                  :options="chapters"
                                  label="name"
                                  :disabled="!chapters.length"
                                  :reduce="item => item.name"
                                  @input="() => { getTopics(); }"
                                  v-model="filters.chapter">
                            <template #list-header>
                                <li style="text-align: center" v-if="!chapters.length">Loading Chapters...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'filter-disabled': !topics.length}">
                    <div class="d-flex align-center">
                        <span class="label">Topic: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Topic"
                                  :options="topics"
                                  label="name"
                                  :clearable="false"
                                  :disabled="!topics.length"
                                  :reduce="item => item.name"
                                  @input="() => { fetchItems() }"
                                  v-model="filters.topic">
                            <template #list-header>
                                <li style="text-align: center" v-if="!topics.length">Loading Topics...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half">
                <div class="vx-col w-full">
                    <vx-input-group class="custom-input-group">
                        <div class="d-flex">
                            <span class="label">Media Type: </span>
                            <div class="vx-input-group-append flex-grow">
                                <div class="append-text btn-addon">
                                    <vs-button
                                        color="primary"
                                        type="border"
                                        v-for="(v, i) in types"
                                        :key="i"
                                        @click="toggleMediaType(v.value)"
                                        class="radiobtn"
                                        :class="{selected: filters.asset_types.indexOf(v.value) !== -1}">
                                        {{v.name}}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </vx-input-group>
                </div>
            </div>
            <div class="vx-row gutter-half d-flex align-center radio-btns">
                <div class="vx-col w-full sm:w-full md:w-1/2">
                    <div class="d-flex">
                        <span class="label">Academic Reviewed: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('academic_reviewed', true)"
                                    class="radiobtn"
                                    :class="{selected: filters.academic_reviewed && filters.academic_reviewed !== 'any'}">
                                    Yes
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('academic_reviewed', false)"
                                    class="radiobtn"
                                    :class="{selected: !filters.academic_reviewed}">
                                    No
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('academic_reviewed', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.academic_reviewed === 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/2">
                    <div class="d-flex">
                        <span class="label">Artist Reviewed: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('artist_reviewed', true)"
                                    class="radiobtn"
                                    :class="{selected: filters.artist_reviewed && filters.artist_reviewed !== 'any'}">
                                    Yes
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('artist_reviewed', false)"
                                    class="radiobtn"
                                    :class="{selected: !filters.artist_reviewed}">
                                    No
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('artist_reviewed', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.artist_reviewed === 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row gutter-half d-flex align-center radio-btns">
                <div class="vx-col w-full sm:w-full md:w-2/3">
                    <div class="d-flex">
                        <span class="label">Visibility: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'internal_only')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'internal_only'}">
                                    Internal Only
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'b2b')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'b2b'}">
                                    B2B
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'public')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'public'}">
                                    Public
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('visibility', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.visibility == 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/3">
                    <div class="d-flex">
                        <span class="label">Readiness: </span>
                        <div class="vx-input-group-append flex-grow">
                            <div class="append-text btn-addon">
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('published', false)"
                                    class="radiobtn"
                                    :class="{selected: !filters.published}">
                                    Draft
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('published', true)"
                                    class="radiobtn"
                                    :class="{selected: filters.published && filters.published !== 'any'}">
                                    Published
                                </vs-button>
                                <vs-button
                                    color="primary"
                                    type="border"
                                    @click="setRadioBtn('published', 'any')"
                                    class="radiobtn"
                                    :class="{selected: filters.published === 'any'}">
                                    Any
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
        <vx-card>
            <div class="pagination-block" style="margin: 20px 0 30px 0">
                <vs-pagination :total="totalPages" :max="7" v-model="currentPage" v-if="totalPages > 1"
                               @change="handlePaginationChange"></vs-pagination>
            </div>
            <div class="vx-row gutter-half mb-5 mt-3 d-flex align-center justify-center relative">
                <div class="vx-col w-full sm:w-full md:w-1/4">
                    <div class="d-flex align-center">
                        <span class="label">Primary language: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select primary language"
                                  :options="languages.filter(item => !secondaryLang || item.code !== secondaryLang)"
                                  label="name"
                                  :clearable="false"
                                  :reduce="item => item.code"
                                  v-model="primaryLang">
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/4">
                    <div class="d-flex align-center">
                        <span class="label">Secondary language: </span>
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select secondary language"
                                  :options="$store.state.languages.filter(item => !primaryLang || item.code !== primaryLang)"
                                  label="name"
                                  :reduce="item => item.code"
                                  v-model="secondaryLang">
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>

                <div class="translation-save-btn">
                    <vs-button color="primary" :disabled="isLoading || !secondaryLang" @click="save" style="width: 150px">
                        Save
                    </vs-button>
                </div>
            </div>
            <div class="translations-table mt-3">
                <div class="loader-block loader-block2" v-if="isLoading" style="min-height: 200px;">
                    <div class="loading">
                        <div class="effect-1 effects"></div>
                        <div class="effect-2 effects"></div>
                        <div class="effect-3 effects"></div>
                    </div>
                </div>
                <div class="d-flex vs-table-header" >
                    <div style="width: 10%">Asset</div>
                    <div style="width: 25%">Name</div>
                    <div style="width: 35%">Description</div>
                    <div style="width: 25%">Tags</div>
                </div>

                <div class="d-flex translation-row" v-for="(item, index) in items" :key="index">
                    <div style="width: 10%; align-items: flex-start" class="asset-thumbnail-block">
                        <div class="asset-thumbnail-section" style="margin: 0">
                            <router-link :to="`/${item._id}/edit`">
                                <HoverThumb :main="item.thumbnail" :list="item.thumbnails" :asset="item" :ignoreList="true"/>
                            </router-link>
                        </div>
                    </div>

                    <div style="width: 25%">
                        <div class="d-flex align-center mb-2">
                            <div class="mr-2 lang-label-width">{{ primaryLang }}:</div>
                            <vs-input
                                :disabled="true"
                                v-model="item.title"
                                v-if="primaryLang === 'en'"
                            />
                            <vs-input
                                :disabled="true"
                                v-model="item.locales[primaryLang].name"
                                v-else
                            />
                        </div>
                        <div class="d-flex align-center" v-if="secondaryLang">
                            <div class="mr-2 lang-label-width">{{ secondaryLang }}:</div>
                            <vs-input
                                v-model="item.title"
                                v-if="secondaryLang === 'en'"
                            />
                            <vs-input
                                v-model="item.locales[secondaryLang].name"
                                v-else
                            />
                        </div>
                    </div>
                    <div style="width: 40%">
                        <div class="d-flex align-center">
                            <div class="mr-2 lang-label-width">{{ primaryLang }}:</div>
                            <vs-textarea
                                class="resize-vertical mb-2 translation-textarea disabled-textarea"
                                name="description"
                                :disabled="true"
                                rows="1"
                                v-model="item.description"
                                v-if="primaryLang === 'en'"
                            />
                            <vs-textarea
                                class="resize-vertical mb-2 translation-textarea disabled-textarea"
                                name="description"
                                :disabled="true"
                                rows="1"
                                v-model="item.locales[primaryLang].description"
                                v-else
                            />
                        </div>
                        <div class="d-flex align-center" v-if="secondaryLang">
                            <div class="mr-2 lang-label-width">{{ secondaryLang }}:</div>
                            <vs-textarea
                                class="resize-vertical translation-textarea"
                                name="description"
                                v-model="item.description"
                                @keydown.enter.exact.prevent
                                v-if="secondaryLang === 'en'"
                            />
                            <vs-textarea
                                class="resize-vertical translation-textarea"
                                name="description"
                                @keydown.enter.exact.prevent
                                v-model="item.locales[secondaryLang].description"
                                v-else
                            />
                        </div>
                    </div>
                    <div style="width: 25%">
                        <div class="d-flex align-center">
                            <div class="mr-2 lang-label-width">{{ primaryLang }}:</div>
                            <v-select ref="tags" class="w-100 mb-2 no-edit-item" taggable multiple v-model="item.keywords"
                                      :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'keywords', index)"
                                      v-if="primaryLang === 'en'"
                                      :select-on-key-codes="[188, 13]"/>
                            <v-select ref="tags" class="w-100 mb-2 no-edit-item" taggable multiple v-model="item.locales[primaryLang].tags"
                                      :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'tags', index, primaryLang)"
                                      v-else
                                      :select-on-key-codes="[188, 13]"/>
                        </div>
                        <div class="d-flex align-center" v-if="secondaryLang">
                            <div class="mr-2 lang-label-width">{{ secondaryLang }}:</div>
                            <v-select ref="tags" class="w-100" taggable multiple v-model="item.keywords"
                                      :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'keywords', index)"
                                      v-if="secondaryLang === 'en'"
                                      :select-on-key-codes="[188, 13]"/>
                            <v-select ref="tags" class="w-100" taggable multiple v-model="item.locales[secondaryLang].tags"
                                      :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'tags', index, secondaryLang)"
                                      v-else
                                      :select-on-key-codes="[188, 13]"/>
                        </div>
                    </div>
                </div>

                <div v-if="!items || !items.length" style="width: 100%;text-align: center">
                    Nothing here
                </div>
                <div class="pagination-block mb-5">
                    <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"
                                   @change="handlePaginationChange"></vs-pagination>
                </div>
            </div>

        </vx-card>
    </div>
</template>

<script>

import axios from "axios";
import vSelect from 'vue-select'
import HoverThumb from "../components/HoverThumb";

export default {
    name: "Translations",
    components: {vSelect, HoverThumb},
    props: {},
    data() {
        return {
            filters: {
                _search: "",
                subject: "",
                unit: "",
                chapter: "",
                topic: "",
                title: "",
                asset_types: [],
                // _start: 0,
                // _limit: 27,
                order_by: "updatedAt",
                order: "desc",
                academic_reviewed: 'any',
                artist_reviewed: 'any',
                visibility: 'any',
                published: 'any',
                lm_format: '',
                goal: '',
                grade: ''
            },
            subjects: [],
            units: [],
            chapters: [],
            topics: [],
            titles: [],
            goals: [],
            grades: [],
            types: this.$store.state.types,
            items: [],
            currentPage: 1,
            totalItems: 0,
            itemsPerPage: 15,
            totalPages: 0,
            showImages: true,
            isLoading: false,
            lmDebounce: false,
            lmFormats: [],
            primaryLang: 'en',
            secondaryLang: '',
            languages: [{name: 'English', code: 'en'}, ...this.$store.state.languages]
        }
    },
    computed: {
        componentName: () => {
            return "Translations"
        },
        filtersObj() {
            return {
                _search: this.filters._search,
                subject: this.filters.subject,
                unit: this.filters.unit,
                chapter: this.filters.chapter,
                topic: this.filters.topic,
                title: this.filters.title,
                asset_types: this.filters.asset_types.length ? JSON.stringify(this.filters.asset_types) : null,
                _start: (this.currentPage - 1) * this.itemsPerPage,
                _limit: this.itemsPerPage,
                order_by: this.filters.order_by,
                order: this.filters.order,
                academic_reviewed: this.filters.academic_reviewed,
                artist_reviewed: this.filters.artist_reviewed,
                visibility: this.filters.visibility,
                published: this.filters.published,
                lm_format: this.filters.lm_format,
                goal: this.filters.goal,
                grade: this.filters.grade,
            }
        },
        filtersQuery() {
            return Object.keys(this.filtersObj).filter(k => Boolean(this.filtersObj[k]) || this.filtersObj[k] === 0 || k === 'academic_reviewed' || k === 'artist_reviewed' || k === 'published').map(k => `${k}=${this.filtersObj[k]}`).join("&")
        }
    },
    mounted() {
        this.getLMFormats();
        this.fetchItems();
    },
    watch: {
        filtersObj(next, prev) {
            if (!compareObjects(next, prev)) {
                this.fetchItems()
            }
        }
    },
    methods: {
        save() {
            this.isLoading = true;
            let languages = [];
            for (let k in this.items) {
                languages.push({
                    _id: this.items[k]._id,
                    locales: this.items[k].locales,
                })
            }
            let url = '/assets/translations';
            this.$axios.post(url, languages).then((res) => {
                this.isLoading = false;
                this.$vs.notifyWrapper({
                    color: 'success',
                    fixed: true,
                    title: 'Updated Successfully'
                })
            }).catch(e => {
                this.isLoading = false;
            })
        },
        handleCreatedTag(map, vm, key, index, lang) {
            const create = (e) => {
                e.preventDefault();
                let items = lang ? this.items[index].locales[lang][key] : this.items[index][key];
                items.push(...vm.search.replace(/"/g, "").split(",").map(t => t.trim()).filter(t => t && items.indexOf(t) === -1))
                vm.search = "";
                setTimeout(() => {
                    vm.searchEl.focus()
                }, 100)
            }
            map[13] = create
            map[188] = create
            return map;
        },
        getLMFormats() {
            let url = `/lm-formats?lm_type=learning_map` + '&search=' + '';
            this.$axios.get(url).then(res => {
                this.lmFormats = res.data._items;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        setRadioBtn(type, val) {
            this.filters[type] = val;
        },
        toggleMediaType(type) {
            let ind = this.filters.asset_types.indexOf(type);
            if (ind === -1) {
                this.filters.asset_types.push(type)
            } else {
                this.filters.asset_types.splice(ind, 1)
            }
        },
        clear(fieldName) {
            const  map = ['goals', 'grades', 'subjects', 'units', 'chapters', 'topics', 'titles'].reverse();
            const clearMap = {
                goals: () => {this.goals = []; this.filters.goal = ''},
                grades: () => {this.grades = []; this.filters.grade = ''},
                subjects: () => {this.subjects = []; this.filters.subject = ''},
                units: () => {this.units = []; this.filters.unit = ''},
                chapters: () => {this.chapters = []; this.filters.chapter = ''},
                topics: () => {this.topics = []; this.filters.topic = ''},
                titles: () => {this.titles = []; this.filters.title = ''},
            }
            let ind = map.indexOf(fieldName);
            if (ind < 0) return;
            for (let i=0; i<=ind; i++) {
                clearMap[map[i]]();
            }
            this.items = [];
            this.totalPages = 0;
        },
        gradeOnChange(newVal) {
            if (newVal[0] !== this.filters.grade[0] || newVal[1] !== this.filters.grade[1]) {
                this.filters.grade = newVal;
                clearTimeout(this.gradeTimeout);
                this.gradeTimeout = setTimeout(()=> {
                    this.getSubjects();
                }, 1000)
            }

        },
        getGoals() {
            if (this.filters.lm_format) {
                this.clear("goals");
                let url = `/goals-list?id=${this.filters.lm_format}`;
                this.$axios.get(url).then(res => {
                    this.goals = Object.values(res.data)[0];
                }).catch(e => {
                    console.log(url, e.message)
                })
            }
        },
        getGrades() {
            this.clear("grades");
            let url = `/grades-list?id=${this.filters.lm_format}`;
            url += '&goal=' + this.filters.goal;
            this.$axios.get(url).then(res => {
                this.grades = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getSubjects() {
            this.clear("subjects");
            let url = `/subject-list?id=${this.filters.lm_format}`;
            url += '&goal=' + this.filters.goal;
            url += '&grade=' + this.filters.grade;
            this.$axios.get(url).then(res => {
                this.subjects = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getUnits() {
            this.clear("units");
            let url = `/units-list?id=${this.filters.lm_format}`;
            url += '&goal=' + this.filters.goal;
            url += '&grade=' + this.filters.grade;
            url += '&subject=' + this.filters.subject;
            this.$axios.get(url).then(res => {
                this.units = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getChapters() {
            this.clear("chapters");
            let url = `/chapters-list?id=${this.filters.lm_format}`;
            url += '&goal=' + this.filters.goal;
            url += '&grade=' + this.filters.grade;
            url += '&subject=' + this.filters.subject;
            url += '&unit=' + this.filters.unit;
            this.$axios.get(url).then(res => {
                this.chapters = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getTopics() {
            this.clear("topics");
            let url = `/topics-list?id=${this.filters.lm_format}`;
            url += '&goal=' + this.filters.goal;
            url += '&grade=' + this.filters.grade;
            url += '&subject=' + this.filters.subject;
            url += '&unit=' + this.filters.unit;
            url += '&chapter=' + this.filters.chapter;
            this.$axios.get(url).then(res => {
                this.topics = Object.values(res.data)[0];
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        getTitles() {
            this.clear('titles')
            let url = `/titles-list?${this.filtersQuery}`;
            this.$axios.get(url).then(res => {
                this.titles = res.data;
            }).catch(e => {
                console.log(url, e.message)
            })
        },
        clearSearch() {
            this.filters._search = "";
            this.isLoading = false;
            if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                this.cancelSearchToken.cancel({err: "Operation canceled by user action."});
            }
        },
        handlePaginationChange(page) {
            if (page != this.currentPage) {
                this.fetchItems();
            }
        },
        fetchItems(force) {
            // if (this.filters._search.length < 3) return;
            this.isLoading = true;
            clearTimeout(this.fetchDebounce);
            this.fetchDebounce = setTimeout(() => {
                this.items = [];
                if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                    this.cancelSearchToken.cancel({err: "Operation canceled by new search.", newSearch: true});
                }
                this.conceptsLoading = true;
                this.cancelSearchToken = axios.CancelToken.source();
                this.$axios.get(`/assets/adv-search?${this.filtersQuery}`, {cancelToken: this.cancelSearchToken.token}).then(res => {
                    if (res.data && res.data.items && res.data.items.length) {
                        let items = res.data.items;
                        for (let k in items) {
                            let locales = {};
                            let d = items[k];
                            for (let k in this.$store.state.languages) {
                                if (d.locales && d.locales[this.$store.state.languages[k].code]) {
                                    locales[this.$store.state.languages[k].code] = {
                                        name: d.locales[this.$store.state.languages[k].code].name,
                                        description: d.locales[this.$store.state.languages[k].code].description,
                                        tags: [...new Set(d.locales[this.$store.state.languages[k].code].tags)]
                                    };
                                } else {
                                    locales[this.$store.state.languages[k].code] = {
                                        name: '',
                                        description: '',
                                        tags: []
                                    }
                                }
                            }
                            d.locales = locales;
                        }

                        this.items = items;
                    }
                    this.totalItems = res.data.total;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                    this.isLoading = false;
                    this.cancelSearchToken = null;
                }).catch(e => {
                    console.log('catch_search', e)
                    this.items = [];
                    this.isLoading = Boolean(e.message.newSearch);
                    this.cancelSearchToken = null;
                })
            }, 500)
        },
    },
}
function compareObjects(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
}
</script>
